module.exports = __webpack_public_path__ + "img/pointF_item1.7f6246b2.png";